module.exports = __webpack_public_path__ + "static/media/towerview.b5b3f4df.png";